export default __webpack_public_path__ + "static/media/yelpCamp2.8ac1997f.jpg";